import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, FormActions, Checkbox, FormFileUpload } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withNamespaces } from 'react-i18next';

const DocumentUploadForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, initialValues, fileLabel, submitLabel, t }) => {

	const documentData = initialValues && initialValues.document && {
		filename: document.filename
	};
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='name' component={Input} type='hidden' horizontal />
			<Field name='documentId' component={FormFileUpload} disabled={isReadonly} horizontal label={fileLabel ? fileLabel : t('FO_IndividualConsultation_Document_File')} initialData={documentData} />
			<FormActions horizontal>
				<Button type='submit' disabled={isReadonly || pristine || submitting} bsStyle='primary'>{submitLabel ? submitLabel : t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'documentForm' })(withNamespaces()(DocumentUploadForm));
